import React from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { useNavigate } from 'react-router-dom'
import MediaWithShimmer from './MediaWithShimmer'

import purple5 from '../imgs/purple5.jpg'
import purple7 from '../imgs/purple7.jpg'
import purple1 from '../imgs/purple1.jpg'
import purple2 from '../imgs/purple2.jpg'
import purple3 from '../imgs/purple3.jpg'
import purple4 from '../imgs/purple4.jpg'
import purple6 from '../imgs/purple6.jpg'
import purple8 from '../imgs/purple8.jpg'
import purple9 from '../imgs/purple9.jpg'
import purple10 from '../imgs/purple10.jpg'
import purple11 from '../imgs/purple11.jpg'

const PurpleCoutureCollection = () => {
  const { language } = useLanguage()
  const t = translations.purpleCouture
  const navigate = useNavigate()
  const images = [
    purple7,
    purple5,
    purple1,
    purple2,
    purple3,
    purple4,
    purple6,
    purple8,
    purple9,
    purple10,
    purple11
  ]

  return (
    <section
      id="purple-couture"
      className="bg-white cursor-pointer"
      onClick={() => navigate('/shop')}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 md:py-10 pt-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {images.map((src, index) => (
            <MediaWithShimmer
              key={index}
              src={src}
              alt={`Purple Collection ${index + 1}`}
              wrapperClassName="h-[520px] md:h-[580px]"
              className="w-full object-cover rounded-xl shadow-md"
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default PurpleCoutureCollection
